import React from 'react';
import {getBackwardTextLimitBy} from "../../../commonmethod/CommonMethod";

function DiligenceInfo({data}) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE
    return (
            <div className={"thumb-each-info"}>
                <table className={"w-full"}>
                    <tbody>
                    <tr className={"h-[25px]"}>
                        <td className="thumbnail-title">
                            <span className="ticket">{data.tickets}</span>
                            | {data.title ? (data.title.length > 24 ? `${data.title.substring(0, 23)}...` : data.title) : "—"}
                        </td>
                    </tr>
                    <tr className={"h-[22px]"}>
                        <td className="thumbnail-assetCode">
                            실사 요청일 : {data.reqStartDate?.substring(0, 10) ?? "—"} ~ {data.reqEndDate?.substring(0, 10) ?? "—"}
                        </td>
                    </tr>
                    <tr className={"h-[30px]"}>
                        <td className="thumbnail-user">
                            <span className="inline-block w-[50%]">
                                [요청자] {data.requestedBy?.name ?? "—"}{" "}
                            </span>
                            [담당자] {data.handler?.[0]?.name ?? "—"}
                            {data.handler?.length > 1 ? ` 외 ${data.handler.length - 1}명` : ""}
                        </td>
                    </tr>
                    <tr className={"h-[25px]"}>
                        <td>
                            {data.code &&
                                <span
                                    className="thumb-ag text-[11px] px-[8px] py-[3px] mr-1">{getBackwardTextLimitBy(data.code.name, 8)}</span>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
    );
}

export default DiligenceInfo;